import { useCallback, useEffect, useState } from 'react';

import capitals from '../data/countryCapitals';
import { locationsApi } from '../api';

type BackendCounts = Record<string, number>;

type CityLocation = {
  latitude: number;
  longitude: number;
  user_count: number;
};

const byIso2 = new Map(
  (capitals as any[]).map((c) => [c.cca2.toUpperCase(), c]),
);

export const useUserLocations = () => {
  const [userLocations, setUserLocations] = useState<BackendCounts>({});

  const getUserCities = useCallback(
    (data: BackendCounts): Record<string, CityLocation> => {
      const result: Record<string, CityLocation> = {};

      for (const [iso2Raw, count] of Object.entries(data)) {
        const iso2 = iso2Raw.toUpperCase();

        const entry = byIso2.get(iso2);
        if (!entry) {
          continue; // eslint-disable-line no-continue
        }

        const capital = entry.capital?.[0] ?? null;

        const coords = entry.capitalInfo?.latlng;
        if (!capital || !coords?.length || coords.length !== 2) {
          continue; // eslint-disable-line no-continue
        }

        result[capital] = {
          latitude: coords[0],
          longitude: coords[1],
          user_count: count,
        };
      }

      return result;
    },
    [],
  );

  const allUsersLocations = getUserCities(userLocations);

  useEffect(() => {
    locationsApi.getAllUserLocations((res: BackendCounts | {}) => {
      setUserLocations(res as BackendCounts);
    });
  }, []);

  return { allUsersLocations };
};
